import { memo } from 'react'
import styles from '../LandingPage.module.scss'

const Frame1Copy = () => {
  return (
    <div className={`${styles.copyWrapper} gap-12 md:mb-12`}>
      <div className={styles.frame1Top}>
        <h4 className="text-white text-[36px] font-decimal">Our Approach</h4>
        <p className="text-white text-[18px] font-decimal">
          The Reparations Movement has been active for centuries and continues
          to grow.
        </p>{' '}
        <p className="text-white text-[18px] font-decimal">
          The interactive map identifies organizations at the local level and
          allows for filtering across several data points. We display two main
          types of reparations organizations:
        </p>
        <ul className="list-disc pl-6 text-white text-[16px] font-decimal">
          <li>
            <p>
              <strong>Initiatives</strong> are a specific, place- or population
              focused reparations effort.
            </p>
          </li>
          <li>
            <p>
              <strong>Movement Partners</strong> are organizations, collectives,
              or leaders supporting one or more reparations initiatives.
            </p>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default memo(Frame1Copy)
